import React, { useEffect, useState } from "react";
import dashboard from "../../gql/dashboard";
import { useQuery } from "@apollo/client";
import DashboardFilter from "./DashboardFilter";
import Button from "@mui/material/Button";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Tooltip } from "@mui/material";
import DashboardCharts from "./DashboardChart";
import { useFormik } from "formik";
import ptpa from "../../gql/ptpa";
import { useTranslation } from "react-i18next";
import DashBoardLoading from "../../common/DashBoardLoading";
import AppButton from "../../shared/AppButton";

function Dashboard(props) {
  const currentDate = new Date();
  const [showFilter, setShowFilter] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const approvalRate = 50;
  const claimApprovalRate = 40;

  const [fromDate, setFromDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-01`,
  );
  const [toDate, setToDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-${new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0,
    ).getDate()}`,
  );
  const { loading, error, data, refetch } = useQuery(
    dashboard.DASHBOARD_STATS,
    {
      variables: { filters: { from_date: fromDate, to_date: toDate } },
      fetchPolicy: "no-cache",
    },
  );

  useEffect(() => {
    if (data?.getDashboardStats?.data) {
      setDashboardData({
        accepted_claims: data?.getDashboardStats?.data?.accepted_claims || 0,
        accepted_pre_auth:
          data?.getDashboardStats?.data?.accepted_pre_auth || 0,
        active_verification:
          data?.getDashboardStats?.data?.active_verification || 0,
        cancelled_claims: data?.getDashboardStats?.data?.cancelled_claims || 0,
        errored_claims: data?.getDashboardStats?.data?.errored_claims || 0,
        errored_pre_auth: data?.getDashboardStats?.data?.errored_pre_auth || 0,
        not_active_verification:
          data?.getDashboardStats?.data?.not_active_verification || 0,
        partial_claims: data?.getDashboardStats?.data?.partial_claims || 0,
        partial_pre_auth: data?.getDashboardStats?.data?.partial_pre_auth || 0,
        patients: data?.getDashboardStats?.data?.patients || 0,
        pending_claims: data?.getDashboardStats?.data?.pending_claims || 0,
        pending_pre_auth: data?.getDashboardStats?.data?.pending_pre_auth || 0,
        rejected_claims: data?.getDashboardStats?.data?.rejected_claims || 0,
        rejected_pre_auth:
          data?.getDashboardStats?.data?.rejected_pre_auth || 0,
        total_claims: data?.getDashboardStats?.data?.total_claims || 0,
        total_pre_auth: data?.getDashboardStats?.data?.total_pre_auth || 0,
        total_verification:
          data?.getDashboardStats?.data?.total_verification || 0,
      });
    }
  }, [data?.getDashboardStats?.data]);

  function formatDate(inputDate) {
    // Create a new Date object from the input date string
    var date = new Date(inputDate);

    // Define months array
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Extract the components of the date
    var year = date.getFullYear();
    var month = months[date.getMonth()];
    var day = date.getDate();

    // Format the date
    var formattedDate =
      month + " " + (day < 10 ? "0" + day : day) + ", " + year;

    // Return the formatted date
    return formattedDate;
  }

  const formik = useFormik({
    initialValues: {
      from_date: `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-01`,
      to_date: `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-${new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0,
      ).getDate()}`,
    },
    onSubmit: async (values, { setSubmitting }) => {
      setIsFilterLoading(true);
      try {
        await refetch({
          filters: Object.keys(values).reduce((acc, key) => {
            const value = values[key];
            if (value !== "" && value !== null) {
              acc[key] = value;
            }
            return acc;
          }, {}),
        });
      } finally {
        setIsFilterLoading(false);
        setSubmitting(false);
      }
    },
  });

  const {
    loading: loadingPayers,
    error: errorPayer,
    data: payersData,
    refetch: refetchPayers,
  } = useQuery(ptpa.GET_ALL_PAYERS);

  React.useEffect(() => {
    if (payersData) {
      localStorage.setItem(
        "payersData",
        JSON.stringify(payersData.listPayersWithTpa.data),
      );
    }
  }, [payersData]);
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="row">
        <div className="flex w-full justify-end mb-2">
          {/* <div className="flex items-center gap-2">
            <div className="text-base  text-gray-600 font-semibold">
              <span className="font-medium">{t("Filter By")}: </span>{" "}
              {formatDate(formik.values.from_date)} -{" "}
              {formatDate(formik.values.to_date)}
            </div>
          </div> */}
          {/* <AppButton
            variant="outlined"
            label={t("Filter Toggle")}
            startIcon={<FilterAltOutlinedIcon className="text-[13px]" />}
            onClick={() => setShowFilter(() => !showFilter)}
            className=" !border-primary !text-primary hover:!bg-primary/10"
          /> */}
        </div>
        {showFilter && (
          <div>
            <DashboardFilter
              formik={formik}
              showFilter={showFilter}
              setShowFilter={setShowFilter}
              isLoading={loading || isFilterLoading}
            />
          </div>
        )}
        <div className="">
          {loading || isFilterLoading ? (
            <div className="">
              <DashBoardLoading />
            </div>
          ) : (
            data?.getDashboardStats?.data && (
              <div className="opacity-100">
                {dashboardData && <DashboardCharts data={dashboardData} />}
              </div>
            )
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Dashboard;
